import { Channels } from 'generated-graphql/types';
import { CHANNEL_LABEL_BY_CHANNEL_VALUE } from 'common';
import { Fields, FormOption } from 'common/form';
import { SourcingSharedChooseChannelFormData } from 'modules/sourcing-shared/forms';

type GetSourcingSharedChooseChannelFieldsProps = {
  availableChannels: Channels[];
  defaultFormData: SourcingSharedChooseChannelFormData;
};

export const getSourcingSharedChooseChannelFields = ({
  availableChannels,
  defaultFormData
}: GetSourcingSharedChooseChannelFieldsProps): Fields<SourcingSharedChooseChannelFormData> => {
  const channelOptions: FormOption[] = availableChannels.map((channel) => ({
    value: channel,
    label: CHANNEL_LABEL_BY_CHANNEL_VALUE[channel]
  }));

  return {
    channel: {
      type: 'radio',
      label: 'Invite candidates via',
      options: channelOptions,
      defaultValue: defaultFormData.channel
    }
  };
};
